import React from "react";
import { Field } from "formik";
import { Trans, useTranslation } from "react-i18next";
import { Alert, Input } from "components/bootstrap";
import { Link, Spinner } from "components/common";
import AppConfig from "util/AppConfig";
import DataTieringRoutes from "./Routes";
import { STORAGE_REPOSITORY_TYPE_LABELS } from "./repository-management/types";
import useRepositories from "./repository-management/hooks/useRepositories";
import RepositorySelect from "./repository-management/RepositorySelect";
const RepositoryManagement = ({
  valuesPrefix = void 0,
  disabled = false,
  fieldName: fieldNameProp = void 0,
  type = void 0,
  types = void 0,
  layout = "vertical",
  label: labelProp = void 0,
  help: helpProp = void 0
}) => {
  const { t } = useTranslation("enterprise_data_tiering");
  const label = labelProp != null ? labelProp : t("repository_management.label");
  const help = helpProp != null ? helpProp : t("repository_management.help");
  const isCloud = AppConfig.isCloud();
  const isHorizontal = layout === "horizontal";
  const typeFilter = types != null ? types : type;
  const { repositories } = useRepositories(typeFilter);
  const typePrefix = type ? `${STORAGE_REPOSITORY_TYPE_LABELS[type]} ` : "";
  const resolvedFieldName = fieldNameProp != null ? fieldNameProp : valuesPrefix ? `${valuesPrefix}.data_tiering.warm_tier_repository_name` : "data_tiering.warm_tier_repository_name";
  const renderContent = () => {
    var _a, _b;
    if (repositories.isLoading) {
      return /* @__PURE__ */ React.createElement(Spinner, { text: t("repository_management.fetching") });
    }
    if (((_b = (_a = repositories.data) == null ? void 0 : _a.length) != null ? _b : 0) === 0) {
      return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, t("repository_management.no_repositories", { type_prefix: typePrefix }), " ", isCloud ? t("repository_management.create_via_api") : /* @__PURE__ */ React.createElement(
        Trans,
        {
          t,
          i18nKey: "repository_management.create_on_page",
          components: { pageLink: /* @__PURE__ */ React.createElement(Link, { to: DataTieringRoutes.WARM_TIER_REPOSITORIES }) }
        }
      ));
    }
    return /* @__PURE__ */ React.createElement(RepositorySelect, { disabled, fieldName: resolvedFieldName, type: typeFilter });
  };
  return /* @__PURE__ */ React.createElement(Field, { name: resolvedFieldName }, ({ meta: { error, touched } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      bsStyle: error && touched ? "error" : void 0,
      help,
      error: touched ? error : void 0,
      id: "default-roles-select",
      label,
      labelClassName: isHorizontal ? "col-sm-3" : void 0,
      wrapperClassName: isHorizontal ? "col-sm-9" : void 0
    },
    renderContent()
  ));
};
export default RepositoryManagement;
